var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import { DELETE_WEBHOOK_SUCCESS, FILTER_WEBHOOK_LIST, GET_ALL_WEBHOOKS_SUCCESS, GET_MSISDNS_FOR_WEBHOOKS_SUCCESS, GET_SINGLE_WEBHOOK_SUCCESS, GET_WEBHOOK_TYPES_SUCCESS } from 'app/webhooks/webhooks.actions';
import { createSelector } from 'reselect';
export var initialState = {
    list: [],
    showType: 'ALL',
    types: [],
    msisdnsForWebhooks: [],
    listFilter: 'ALL'
};
export function webhooksReducer(state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case GET_ALL_WEBHOOKS_SUCCESS:
            return __assign({}, state, { list: action.payload, currentWebhook: null, listFilter: 'ALL' });
        case GET_WEBHOOK_TYPES_SUCCESS:
            return __assign({}, state, { types: action.payload });
        case GET_MSISDNS_FOR_WEBHOOKS_SUCCESS:
            return __assign({}, state, { msisdnsForWebhooks: action.payload });
        case GET_SINGLE_WEBHOOK_SUCCESS:
            return __assign({}, state, { currentWebhook: action.payload });
        case DELETE_WEBHOOK_SUCCESS: {
            return __assign({}, state, { list: state.list.filter(function (webhook) { return webhook.id !== action.payload; }) });
        }
        case FILTER_WEBHOOK_LIST:
            return __assign({}, state, { listFilter: action.payload });
        default:
            return state;
    }
}
var getList = function (state) { return state.list; };
var ɵ0 = getList;
var getFilteredList = function (state) {
    return state.listFilter === 'ALL' ? state.list : state.list.filter(function (webhook) { return webhook.subjectType === state.listFilter; });
};
var ɵ1 = getFilteredList;
var getTypes = function (state) { return state.types; };
var ɵ2 = getTypes;
var getMsisdnsForWebhooks = function (state) { return state.msisdnsForWebhooks; };
var ɵ3 = getMsisdnsForWebhooks;
var getCurrent = function (state) { return state.currentWebhook; };
var ɵ4 = getCurrent;
export var getMainWebhooksSelector = function (state) { return state.webhooks; };
export var getWebhookListSelector = createSelector(getMainWebhooksSelector, getList);
export var getWebhookFilteredListSelector = createSelector(getMainWebhooksSelector, getFilteredList);
export var getWebhookTypesSelector = createSelector(getMainWebhooksSelector, getTypes);
export var getMsisdnsForWebhooksSelector = createSelector(getMainWebhooksSelector, getMsisdnsForWebhooks);
export var getCurrentWebhookSelector = createSelector(getMainWebhooksSelector, getCurrent);
export { ɵ0, ɵ1, ɵ2, ɵ3, ɵ4 };
